/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetMetaMcpServerSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetMetaMcpServerSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetMetaMcpServerSecurity = {
  option1?: GetMetaMcpServerSecurityOption1 | undefined;
  option2?: GetMetaMcpServerSecurityOption2 | undefined;
};

export type GetMetaMcpServerRequest = {
  /**
   * The ID of the meta MCP server
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetMetaMcpServerSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetMetaMcpServerSecurityOption1$outboundSchema: z.ZodMiniType<
  GetMetaMcpServerSecurityOption1$Outbound,
  GetMetaMcpServerSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getMetaMcpServerSecurityOption1ToJSON(
  getMetaMcpServerSecurityOption1: GetMetaMcpServerSecurityOption1,
): string {
  return JSON.stringify(
    GetMetaMcpServerSecurityOption1$outboundSchema.parse(
      getMetaMcpServerSecurityOption1,
    ),
  );
}

/** @internal */
export type GetMetaMcpServerSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetMetaMcpServerSecurityOption2$outboundSchema: z.ZodMiniType<
  GetMetaMcpServerSecurityOption2$Outbound,
  GetMetaMcpServerSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function getMetaMcpServerSecurityOption2ToJSON(
  getMetaMcpServerSecurityOption2: GetMetaMcpServerSecurityOption2,
): string {
  return JSON.stringify(
    GetMetaMcpServerSecurityOption2$outboundSchema.parse(
      getMetaMcpServerSecurityOption2,
    ),
  );
}

/** @internal */
export type GetMetaMcpServerSecurity$Outbound = {
  Option1?: GetMetaMcpServerSecurityOption1$Outbound | undefined;
  Option2?: GetMetaMcpServerSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetMetaMcpServerSecurity$outboundSchema: z.ZodMiniType<
  GetMetaMcpServerSecurity$Outbound,
  GetMetaMcpServerSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetMetaMcpServerSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetMetaMcpServerSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getMetaMcpServerSecurityToJSON(
  getMetaMcpServerSecurity: GetMetaMcpServerSecurity,
): string {
  return JSON.stringify(
    GetMetaMcpServerSecurity$outboundSchema.parse(getMetaMcpServerSecurity),
  );
}

/** @internal */
export type GetMetaMcpServerRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetMetaMcpServerRequest$outboundSchema: z.ZodMiniType<
  GetMetaMcpServerRequest$Outbound,
  GetMetaMcpServerRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function getMetaMcpServerRequestToJSON(
  getMetaMcpServerRequest: GetMetaMcpServerRequest,
): string {
  return JSON.stringify(
    GetMetaMcpServerRequest$outboundSchema.parse(getMetaMcpServerRequest),
  );
}
